import { apiClient } from '@/services/ApiClient.js'

export class ProductPriceService {
  static exportProductPrices(query) {
    return apiClient
      .get('retailer-product-prices/export', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static startImportMobilePricesProcess(form) {
    let formData = new FormData()
    formData.append('file', form.file)

    return apiClient
      .postForm('/retailer-product-prices/import', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  query

  constructor(query) {
    this.query = query
  }

  getRetailerProductPrices() {
    return apiClient
      .get('retailer-product-prices', {
        params: this.query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
